import React, { useContext, useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import usePartnerName from "../../hooks/usePartnerName";
import { urlShortener } from "../../utils/helper";
import { GlobalContext } from "../globalContext/GlobalContext";
import { Help, HelpActive, Home, HomeActive, Support, SupportActive, PrivacyPolicy } from '../Icons/Icons';
import './footer.scss';
import { toast } from "react-toastify";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import { Modal } from "antd";
import FooterPDFViewerModal from "./FooterPDFViewerModal";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";

// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

const footerLinks = [
    // { displayName: 'Share web link', link: `#`, },
    { displayName: 'Privacy Policy', link: `#`, },
    { displayName: 'Terms of Use', link: `/terms-and-conditions`, },
    { displayName: 'Legal', link: `#`, },
    { displayName: 'Cookie Policy', link: `#`, },
    { displayName: 'Help', link: '/help', },
    { displayName: 'Support and feedback', link: '/feedback', onclick: () => { } }
]

const Footer = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { globalState } = useContext(GlobalContext);
    const partner = useSelector(state => state.global.partner)
    const { formattedName: localStoragePartnerName } = usePartnerName()
    const localData = useSelector((state) => state?.localStorage)
    const { micrositeName: localDataMicroSiteName, partnerId, partner: subDomainName } = localData
    const [shortenedUrl, setShortenedUrl] = useState(window.location.href)
    const micrositeName = localDataMicroSiteName;
    const localStoragePartnerId = partnerId;

    const [footerDocumentsData, setFooterDocumentsData] = useState([]);
    const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
    const [selectedFooterData, setSelectedFooterData] = useState(null);

    const getShortenUrl = async () => {
        const shareFromMicroDetail = window?.location?.href?.includes('micrositeDetails')
        let url = ''
        // micrositeName in local storage is saved with " " for sharing replace it with "_"
        const microDetailUrl = `${window?.origin}/microsite/${micrositeName?.replace(/ /g, "_")}`

        url = `${shareFromMicroDetail ? microDetailUrl :
            window.location.href}?partnerId=${partner?.id ||
            localStoragePartnerId}&partnerName=${encodeURIComponent(subDomainName ||
                localStoragePartnerName)}&fromList=true`
        try {
            let testUrl = new URL(url);
            const shortUrl = testUrl.host !== 'localhost:3000' ? await urlShortener(url) : url;
            setShortenedUrl(shortUrl);
        } catch (error) {
            console.error("Error shortening URL:", error);
            setShortenedUrl(url); // Fallback to original URL
        }
    };


    useEffect(() => {
        getShortenUrl();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [partner, location.pathname]);

    const fetchFooterDocuments = async () => {
        try {
        const response  = await getRequest(
            userapiservice.fetchFooterDocuments(partnerId),
        );
        if(response){
            setFooterDocumentsData(response ?? []);
        } else {
            toast.error("Something went wrong!");
        }
        } catch (error) {
            toast.error(error);
        }
    }

    useEffect(() => {
        if(partnerId){
            fetchFooterDocuments()
        }
    }, [partnerId]);

    const handleViewPdf = (record) => {
        console.log('record----->', record);
        setSelectedFooterData(record);
        setIsPdfModalOpen(true);
    };

    const handleMobileFooter= (footerType) => {
        const data = footerDocumentsData?.find((item) => item?.title === footerType);
        handleViewPdf(data)
    }

    if (globalState.isMobile) {
        return(
            <>
            <footer className="footer-mobile-layout ">
            <ul className="navbar-nav footer-links-container d-flex justify-content-between  align-items-center flex-row h-100">
                <li className="nav-item">
                    <a href="https://www.connectsu.co.uk" target="_blank" rel="noreferrer" className="">
                        <img className='footer-image' src={require("../../assets/images/powered_new_3d.png")} alt="expo365 logo" width="60" height="60" />
                    </a >
                </li>
                <li style={{
                    borderRight: '2px solid #BAC4D2', display: 'inline-block',
                    width: '2px', height: '10px'
                }} >  &nbsp;</li>

                {
                    location.pathname === "/" || location.pathname === "/frontend" ? null : (
                        <li className="nav-item ">
                            <NavLink to={"/"} >
                                {
                                    location.pathname === "/" || location.pathname === "/frontend/Partner_Name" ? <HomeActive /> : <Home />
                                }
                            </NavLink>
                        </li>
                    )
                }
                <li className="nav-item ">
                    <div onClick={ () => handleMobileFooter("Privacy Policy")}>
                        <PrivacyPolicy />
                    </div>
                </li>
                <li className="nav-item ">
                    <NavLink to={"/help"} >
                        {
                            location.pathname === "/help" ? <HelpActive /> : <Help />
                        }
                    </NavLink>
                </li>

                <li className="nav-item ">
                    <NavLink to={"/feedback"} >
                        {
                            location.pathname === "/feedback" ? < SupportActive /> : < Support />
                        }
                    </NavLink>
                </li>
            </ul>
        </footer>

            {
                isPdfModalOpen && <FooterPDFViewerModal
                    open={isPdfModalOpen}
                    onClose={() => {
                        setSelectedFooterData(null);
                        setIsPdfModalOpen(false);
                    }}
                    title={selectedFooterData?.title}
                    fileUrl={selectedFooterData?.fileUrl}
                    isMobile = {globalState.isMobile}
                />
            }
        </>
        )
    }

    return (
        <footer className='footer-desktop-layout row m-0' >
            <div className="footer-image-container col-4 col-md-5 col-lg-6">
                <img
                    role="button"
                    className='footer-image'
                    src={require("../../assets/images/powered_new_3d.png")}
                    onClick={() => window.open("https://www.connectsu.co.uk", "_blank")}
                    alt="Powered By ConnectSU"
                />
            </div>

            <div className="footer-links-copyrights">
            <ul className="footer-links navbar-nav d-flex flex-row align-items-center col-8 col-md-6 col-lg-5">
                {footerLinks.map((ele, i) => {
                    return <React.Fragment key={i}>
                        <li className="nav-item"  >
                            {/* <NavLink to={ele.link} className={`${location.pathname === ele.link ? 'active text-danger' : 'text-primary'} nav-link ${ele.classNames} nav-link-item`}>
                                {ele.displayName}
                            </NavLink> */}

                            <div className={`${location.pathname === ele.link ? 'active text-danger' : 'text-primary'} nav-link ${ele.classNames} nav-link-item`}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    const data = footerDocumentsData?.find((item) => item?.title === ele?.displayName);
                                    const slug = data?.title?.toLowerCase()?.replace(/&/g, "and")?.replace(/\s+/g, "-");
                                    console.log(slug, 'slug=====>', data, "----->", ele?.displayName);
                                    if(["Help", "Support and feedback"]?.includes(ele?.displayName)) {
                                        navigate(ele?.link)
                                    } else if(!!data) {
                                        handleViewPdf(data);
                                        // navigate(`/footer-document/${slug}/${data?.id}`)
                                    }
                                }}
                            >
                                {ele?.displayName}
                            </div>


                        </li>
                    </React.Fragment>
                })}
            </ul>

            <div className="copyrights-container">
                <div className="copyrights-text">
                    {/* <span className="copyright-label"></span> */}
                    <span className="small-text">
                    Copyright © 2026 Connectsu Limited.
                    </span>
                </div>

                <div className="copyrights-text small-text">
                    Registered in England No. 15168817. 111-113 High St, Evesham,
                    Worcestershire, United Kingdom, WR11 4XP.
                </div>
            </div>
            </div>

            {
                isPdfModalOpen && <FooterPDFViewerModal
                    open={isPdfModalOpen}
                    onClose={() => {
                        setSelectedFooterData(null);
                        setIsPdfModalOpen(false);
                    }}
                    title={selectedFooterData?.title}
                    fileUrl={selectedFooterData?.fileUrl}
                    isMobile = {globalState.isMobile}
                />
            }
        </footer>
    )
}

export default Footer